"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SummaryContent = exports.SummaryContainer = exports.IconContainer = exports.DetailsContainer = exports.AccordionItem = exports.Accordion = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _framerMotion = require("framer-motion");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _mixins = require("../../styles/mixins");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function getThemeStyle(_ref) {
  var theme = _ref.theme;
  if (theme === 'plain') {
    return (0, _styledComponents.css)(["border-bottom:1px solid ", ";", ""], _colors["default"].neutral100, getPadding(16));
  }

  // theme === 'regular'
  return (0, _styledComponents.css)(["background-color:", ";margin-bottom:", ";border-radius:2px;", ""], _colors["default"].neutral100, _spacing["default"][12], getPadding(12));
  function getPadding(paddingBlock) {
    return (0, _styledComponents.css)(["", "{padding-block:", "px;}", ":before{content:'';display:block;height:4px;}", ":after{content:'';display:block;height:", "px;}"], SummaryContainer, paddingBlock, DetailsContainer, DetailsContainer, paddingBlock);
  }
}
var Accordion = exports.Accordion = _styledComponents["default"].section.withConfig({
  displayName: "HBAccordionstyles__Accordion",
  componentId: "sc-1ihm930-0"
})(["", ";width:100%;"], _mixins.proximaNova);
var AccordionItem = exports.AccordionItem = _styledComponents["default"].div.withConfig({
  displayName: "HBAccordionstyles__AccordionItem",
  componentId: "sc-1ihm930-1"
})(["color:", ";", ""], _colors["default"].neutral800, getThemeStyle);
var SummaryContainer = exports.SummaryContainer = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBAccordionstyles__SummaryContainer",
  componentId: "sc-1ihm930-2"
})(["display:flex;padding-inline:20px;"]);
var SummaryContent = exports.SummaryContent = _styledComponents["default"].div.withConfig({
  displayName: "HBAccordionstyles__SummaryContent",
  componentId: "sc-1ihm930-3"
})(["font-size:18px;font-weight:600;flex:1;"]);
var DetailsContainer = exports.DetailsContainer = (0, _styledComponents["default"])(_framerMotion.motion.div).withConfig({
  displayName: "HBAccordionstyles__DetailsContainer",
  componentId: "sc-1ihm930-4"
})(["font-size:18px;padding-inline:20px;"]);
var IconContainer = exports.IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBAccordionstyles__IconContainer",
  componentId: "sc-1ihm930-5"
})(["padding-top:3px;"]);
//# sourceMappingURL=HBAccordion.styles.js.map